<template lang="pug">
    div(v-if="train_station.info != null" id="trainstationdepartures")
        h3 {{train_station.info.name}}
        v-simple-table(v-if="next_departures_length > 0" height="280px")
            template(v-slot:default)
                thead
                    tr
                        th(class="text-left") Time
                        th(class="text-left") To
                        th(class="text-left") Train type
                        th(class="text-left") Delay
                tbody
                    tr(v-for="nd in next_departures")
                        td {{ nd.departure_time_hour_string }}
                        td {{ nd.direction }}
                        td {{ nd.train_type }}
                        td {{ nd.departure_delay }}
</template>

<script>
import { TrainStation } from './../js/train_stations'

export default {
    props: {
        train_station: TrainStation,
    },

    data() {
        return {
            next_departures: this.train_station.next_departures,
            next_departures_length: 0,
        }
    },

    watch: {
        train_station: {
            deep: true,
            handler() {
                this.next_departures = this.train_station.next_departures;
                this.next_departures_length = this.train_station.next_departures.length;
            }
        }
    }
}
</script>